/* eslint-disable react/prop-types */
import { MenuItem, Select } from "@mui/material";
import React from "react";
import { useState } from "react";

function CustomDropdownExamname({
  labelName,
  options,
  setInputText,
  defaultValue,
  Isrequired,
  reset,
  x,
}) {
  const [names, setName] = useState(labelName);

  const handleChange = (e) => {
    setName(e?.target?.value?.en?.name);
    setInputText(e.target.value);
  };
  React.useEffect(() => {
    if (reset === true) {
      setName(labelName);
    }
  }, [reset]);

  React.useEffect(() => {
    var newArray;
    if (x === "type") {
      newArray = options?.filter(function (el) {
        return el.value === defaultValue;
      });
      newArray?.forEach((item) => {
        setName(item.name);
        setInputText(item);
      });
    } else if (x === "order") {
      newArray = options?.filter(function (el) {
        return el?.name === defaultValue;
      });
      newArray?.forEach((item) => {
        setName(item.name);
        setInputText(item);
      });
    } else if (x === "ctype") {
      newArray = options?.filter(function (el) {
        return el?.type === defaultValue;
      });
      newArray?.forEach((item) => {
        setName(item.name);
        setInputText(item);
      });
    } else {
      newArray = options?.filter(function (el) {
        return el?._id === defaultValue;
      });
      newArray?.map((item) => {
        setName(item?.name ? item?.name : item?.en?.name);
        setInputText(item);
      });
    }
  }, [defaultValue]);

  return (
    <div className="d-flex mb-2 flex-fill">
      <Select
        className="w-100 bgwhite"
        defaultValue={names}
        value={names}
        label="name"
        required={Isrequired}
        onChange={handleChange}
      >
        <MenuItem disabled value={names}>
          {names}
        </MenuItem>
        {options !== undefined
          ? options.map((item) => (
              <MenuItem key={item._id} value={item}>
                {item?.en?.name}
              </MenuItem>
            ))
          : null}
      </Select>
      {Isrequired ? <span className="required ms-2 fs-6">*</span> : null}
    </div>
  );
}

export default CustomDropdownExamname;
